// Environment configuration
export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8080',
  wsUrl: (import.meta.env.VITE_API_URL || 'http://localhost:8080').replace(/^http/, 'ws'),
} as const;
